import React, { useEffect, Profiler, useState } from 'react'
// import ReactPWAInstallProvider, { useReactPWAInstall } from "react-pwa-install";
// let deferredPrompt; 
const Downloadbutton = () => {
     const [supportsPWA, setSupportsPWA] = useState(false);
  const [promptInstall, setPromptInstall] = useState(null);

  useEffect(() => {
    const handler = e => {
      e.preventDefault();
      console.log("we are being triggered :D");
      setSupportsPWA(true);
      setPromptInstall(e);
    };
    window.addEventListener("beforeinstallprompt", handler);

    return () => window.removeEventListener("transitionend", handler);
  }, []);

  const onClick = evt => {
    evt.preventDefault();
    if (!promptInstall) {
      return;
    }
    promptInstall.prompt();
  };
  if (!supportsPWA) {
    return null;
  }
 

  return (
  
<div
  className="downloadButton"
  style={{
    backgroundColor: "#d0e1f9",
    margin: "0px 10px 10px",
    borderRadius: "50px"
  }}
>
  <div className="text-center">
    <button onClick={onClick} className="btn btn-sm " style={{ fontWeight: 500 }}>
      DOWNLOAD OUR APP
      <img
        src={process.env.PUBLIC_URL + '/Images/arrow.png'}
        alt=""
        style={{ marginLeft: 10, width: "30px" }}
        width="13px"
      />
    </button>
   
  </div>
</div>
   
    
    
  )
}

export default Downloadbutton